module.exports = __webpack_public_path__ + "img/logo2.5a6b95d8.png";